<template>
  <v-expansion-panel-content lazy v-model="toggle" :readonly="readonly"
    class="grey lighten-3" :id="`c${comboId}s${(session)?session._id:0}`" v-bind:class="{'item':draggable}"
  >
      <template v-slot:header>
        <v-container pa-0 fluid>
          <v-layout row fill-height>
            <v-flex xs1>
              <v-layout column align-center justify-center fill-height>
                <v-layout row align-center v-if="draggable">
                  <v-icon small class="sp-drag handle sp-drag">drag_handle</v-icon>
                </v-layout>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-layout row>
                  <v-flex xs12>
                    {{comboSession.title}}
                  </v-flex>
                </v-layout>
                <v-layout row align-center>
                  <v-flex xs12 class="text-xs-right">
                    <template v-if="!editor">
                      <v-btn icon small @click="add" :disabled="editingItem">
                        <v-icon color="success">add</v-icon>
                      </v-btn>
                      <v-btn icon small @click="edit" :disabled="editingItem">
                        <v-icon color="accent">edit</v-icon>
                      </v-btn>
                      <v-btn icon small :disabled="editingItem" @click="$emit('delete',{session:true,id:session._id})">
                        <v-icon color="red">delete</v-icon>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn icon small :loading="loading" @click="save">
                        <v-icon color="success">done</v-icon>
                      </v-btn>
                      <v-btn icon small @click="close">
                        <v-icon color="red">close</v-icon>
                      </v-btn>
                    </template>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
      <v-card>
        <v-card-text class="pt-0">
          <v-form v-if="editor">
            <v-layout row wrap>
                <v-flex xs12>
                    <v-text-field placeholder="Ex: Escolha seu complemento" 
                    label="Nome da Sessão de complementos" v-model="form.title" :error-messages="sessionErrors"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-select v-model="form.selection_type"
                  :items="selection" label="Quantas opções de escolha?"
                >
                </v-select>
              </v-flex>
            </v-layout>
            <template v-if="form.selection_type.startsWith('MANY')">
              <v-layout row align-center>
                <v-flex xs3 sm1 v-if="minItem">
                    <v-text-field label="Mín" type="number" v-model="form.min_itens" min="0">
                    </v-text-field>
                </v-flex>
                <v-flex>
                  <v-switch label="Quantidade mínima" 
                  color="primary" v-model="minItem"
                  >
                    <template slot="append">
                      <sp-tooltip tip="Ex: Escolha pelo menos</br>3 adicionais</br>ou</br>Desmarque para não exigir</br>quantidade mínima">
                      </sp-tooltip>
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>
              <v-layout row align-center>
                <v-flex xs3 sm1 v-if="maxTotal">
                  <v-text-field label="Máx" type="number" v-model="form.max_total_products" min="0">
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-switch label="Quantidade máxima" 
                  color="primary" v-model="maxTotal"
                  >
                    <template slot="append">
                      <sp-tooltip tip="Marque esta opção para limitar a quantidade máximo de produtos">
                      </sp-tooltip>
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>
            </template>
            <v-layout row wrap>
                <v-flex xs12 sm4 v-if="form.selection_type == 'UNIQUE_SELECT'">
                    <v-switch label="Obrigatório" 
                    color="primary" v-model="obrigatorio"
                    >
                      <template slot="append">
                        <sp-tooltip tip="Marque para que seja obrigatória a escolha do complemento">
                        </sp-tooltip>
                      </template>
                    </v-switch>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-switch label="Ocultar valor" 
                    color="primary" v-model="form.zero_value"
                    >
                      <template slot="append">
                        <sp-tooltip tip="Marque para desconsiderar o valor</br>do produto escolhido no complemento. </br>Os valores não serão exibidos.">
                        </sp-tooltip>
                      </template>
                    </v-switch>
                </v-flex>
                <v-flex xs12 sm4>
                    <v-switch label="Ativo" 
                    color="primary" v-model="form.enabled"
                    >
                      <template slot="append">
                        <sp-tooltip tip="Desative para ocultar este complemento.">
                        </sp-tooltip>
                      </template>
                    </v-switch>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
              <v-btn flat small color="grey darken-1" class="mb-0" @click="sessionAdvanced = !sessionAdvanced">
                avançado
                <v-icon v-if="!sessionAdvanced">arrow_drop_down</v-icon>
                <v-icon v-else>arrow_drop_up</v-icon>
              </v-btn>
            </v-layout>
            <template v-if="sessionAdvanced">
              <template v-if="form.selection_type == 'MANY_QTD_SELECT'">
                <v-expand-transition>
                  <v-layout row align-center>
                    <v-flex xs3 sm1 v-if="maxItem">
                        <v-text-field label="Máx" type="number" v-model="form.max_itens" min="0">
                        </v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-switch label="Quantidade máxima de itens na sessão" 
                      color="primary" v-model="maxItem"
                      >
                        <template slot="append">
                          <sp-tooltip tip="Ex: Escolha até 2 molhos</br>ou</br>Desmarque para não ter limites">
                          </sp-tooltip>
                        </template>
                      </v-switch>
                    </v-flex>
                  </v-layout>
                </v-expand-transition>
                <v-expand-transition>
                  <v-layout row align-center>
                    <v-flex xs3 sm1 v-if="maxPerItem">
                      <v-text-field label="Máx" type="number" v-model="form.max_itens_additions" min="0">
                      </v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-switch label="Quantidade máxima de acréscimo por item na sessão" 
                      color="primary" v-model="maxPerItem"
                      >
                        <template slot="append">
                          <sp-tooltip tip="Ex: Escolha seus adicionais: Se o máximo for 2,</br>o cliente só poderá escolher até</br>2 bacons, 2 queijos e 2 hambúrgueres">
                          </sp-tooltip>
                        </template>
                      </v-switch>
                    </v-flex>
                  </v-layout>
                </v-expand-transition>
              </template>
              <v-expand-transition>
                <v-layout row align-center>
                  <v-flex>
                    <v-switch label="Itens pendentes" 
                    color="primary" v-model="form.pending_print"
                    >
                      <template slot="append">
                        <sp-tooltip tip="Itens dessa sessão só serão impressos quando solicitado">
                        </sp-tooltip>
                      </template>
                    </v-switch>
                  </v-flex>
                  <v-flex v-if="form.selection_type == 'MANY_SELECT'">
                    <v-switch label="Marcar todos" 
                    color="primary" v-model="form.autocomplete"
                    >
                      <template slot="append">
                        <sp-tooltip tip="Todos os itens dessa sessão serão marcados automaticamente">
                        </sp-tooltip>
                      </template>
                    </v-switch>
                  </v-flex>
                </v-layout>
              </v-expand-transition>
            </template>
          </v-form>
          <v-list v-else>
            <sp-combo-item v-for="option in comboSession.product_list_data" 
              :key="option.code" :item="option" @update="setSession()"
              :product-list="comboSession.product_list" @refresh="$emit('refresh')"
              :hide-price="comboSession.zero_value" @delete="deleteItem"
              @editing="editing" :hide-actions="editingItem" @newItem="addItem"
            >
            </sp-combo-item>
          </v-list>
        </v-card-text>
      </v-card>
  </v-expansion-panel-content>
</template>

<script>
import SpComboItem from './SpComboItem'
export default {
  components:{
    SpComboItem
  },
  props:['session','comboId','togglePanel','draggable'],
  data(){
    return {
      editor:false,
      form:{
        title:"",
        selection_type:"UNIQUE_SELECT",
        max_itens:0,
        max_itens_additions:0,
        max_total_products:0,
        min_itens:0,
        sum_type:"ADD_PRICE",
        zero_value:false,
        display_order:99,
        enabled:true,
        price_type:"",
        product_list:[],
        pending_print:false,
        autocomplete:false,
      },
      selection:[
        {value:'UNIQUE_SELECT',text:"Somente uma opção"},
        {value:'MANY_SELECT',text:"Várias opções"},
        {value:'MANY_QTD_SELECT',text:"Várias opções com quantidade"},
      ],
      obrigatorio:false,
      toggle:false,
      readonly:false,
      loading:false,
      maxPerItem:false,
      maxTotal:false,
      minItem:false,
      maxItem:false,
      editingItem:false,
      comboSession:{},
      sessionErrors:[],
      sessionAdvanced:false
    }
  },
  mounted(){
    this.setSession()
  },
  watch:{
    session(v){
      this.setSession()
    },
    togglePanel(v){
      if(!v){
        this.setSession()
      }
    },
    maxTotal(v){
      if(!v)
        this.form.max_total_products = 0
    },
    minItem(v){
      if(!v)
        this.form.min_itens = 0
    },
    maxPerItem(v){
      if(!v)
        this.form.max_itens_additions = 0
    },
    maxItem(v){
      if(!v)
        this.form.max_itens = 0
    }
  },
  methods:{
    goTo(){
      if(this.session){
        setTimeout(() => {
          this.$vuetify.goTo(`#c${this.comboId}s${this.session._id}`,
          {
              container:`#combo${this.comboId}`,
              offset:72
          })
        }, 500);
      }
    },
    deleteItem(id){
      if(!id){
        this.comboSession.product_list_data.shift()
      }
      const index = this.comboSession.product_list.findIndex(i=>i == id)
      if(index != -1){
        this.form = Object.assign({},this.comboSession)
        this.form.product_list.splice(index,1)
        this.save()
      }
    },
    addItem(id){
      this.form = Object.assign({},this.comboSession)
      this.form.product_list.push(id)
      this.save()
    },
    async setSession(){
      try {
        if(this.session){
          this.comboSession = this.session
          this.minItem = this.comboSession.min_itens > 0
          this.maxItem = this.comboSession.max_itens > 0
          this.maxPerItem = this.comboSession.max_itens_additions > 0
          this.maxTotal = this.comboSession.max_total_products > 0  
          this.obrigatorio = this.comboSession.min_itens > 0
        }else{
          this.comboSession = {
            title:"",
            selection_type:"UNIQUE_SELECT",
            max_itens:0,
            max_itens_additions:0,
            max_total_products:0,
            min_itens:0,
            sum_type:"ADD_PRICE",
            type_id:"",
            zero_value:false,
            display_order:99,
            enabled:true,
            price_type:"",
            product_list:[],
            pending_print: false,
            autocomplete: false,
          }
          setTimeout(() => {
            this.edit()
          }, 300);
        }
      } catch (error) {
        console.log(error)
      }
    },
    close(){
      if(!this.session){
        this.$emit('delete',null)
      }
      this.editor = false
      this.readonly = false
    },
    add(){
      this.comboSession.product_list_data.unshift({
        productname:"",
        description:"",
        price:0.00,
        active:true
      })
      this.goTo()
      if(this.toggle){
        this.readonly = true
      }else{
        this.toggle = this.readonly = true
      }
    },
    edit(){
      this.form = Object.assign({},this.comboSession)
      this.obrigatorio = this.form.min_itens > 0
      this.editor = true
      this.goTo()
      if(this.toggle){
        this.readonly = true
      }else{
        this.toggle = this.readonly = true
      }
    },
    editing(v){
      this.editingItem = v
      if(!v)
        this.readonly = false
    },
    save(){
      if(!this.form.title.trim()){
        this.sessionErrors = ['Informe o nome do complemento']
        return
      }else{
        this.sessionErrors = []
      }
      this.loading = true
      const data = Object.assign({},this.form)
      data.combolist_id = this.comboId
      if(data._id){
        data.combosession_id = data._id
      }
      if(data.selection_type == "MANY_QTD_SELECT" && !this.maxPerItem){
        data.max_itens_additions = data.max_total_products || 0
      }
      if(data.selection_type == "MANY_SELECT"){
        data.max_itens_additions = data.max_total_products || 0
        data.max_itens = data.max_total_products || 0
      }
      if(data.selection_type == "UNIQUE_SELECT"){
        data.min_itens = this.obrigatorio * 1
      }
      this.$store.dispatch('addeditSession',data).then(res=>{
        if(!this.session){
          this.$emit('newSession')
        }

        this.loading = this.editor = this.readonly = false
        this.comboSession = res

      }).catch(err=>{
          this.error = err
          console.log(err)
          this.loading = false
      })
    }
  }
}
</script>

<style>

</style>